export default __webpack_public_path__ + "static/avatar-tag-2-dont-light-bb91423d718955726e335bdea7f02f07a0e97be55e3edbb8e9a4242a9bf96924.png";